import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllTeachers as apiFn } from "../../api/apiTeachers";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllTeachers() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteAllTeachers, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["teachers"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { forceDeleteAllTeachers, isForceDelete };
}
